import React from 'react'
import { useHookSubscribe } from './hookSubscribe'
import { historyReportsService } from '../../dataFlow'
import { HistoryReportDTO } from '..';

export function useHistoryReports(): [HistoryReportDTO[], (reportId: string, reportName: string) => Promise<void>] {
  const history = useHookSubscribe([], historyReportsService.historyReports$);
  React.useEffect(() => {
    historyReportsService.fetchHistoryReports();
  }, []);

  return [history, historyReportsService.openReport];
}